import React from "react";

import { FormInputField } from "@components-shared/desktop/inputs";
import { ZIPCodePattern } from "@helpers/shared/ZIPCodeValidation";

export default function OnboardingRegistrationZIPCode(props: {
	labelClassName?: string;
}) {
	const { labelClassName } = props;

	return (
		<FormInputField
			id="zipCode"
			className="form__field u-mar--bottom--reset"
			inputClassName="input input--sml"
			name="zipCode"
			label="registration:ZIP_LABEL"
			labelClassName={labelClassName}
			placeholder="registration:ZIP_PLACEHOLDER"
			pattern={{
				value: ZIPCodePattern,
				message: "registration:INVALID_ZIP_CODE",
			}}
			required
		/>
	);
}
